import React from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Redirect, Route, Switch } from 'react-router-dom';

import { Account, Dashboard, Lead, LeadDetail, People } from 'pages';

import { isAnAdmin, isCommercialRole, isPartnerAdmin } from 'utils/common';

const PartnerSwitch = ({ routes, role }) => (
  <Switch>
    <Route exact path={routes.home.path} render={() => <Dashboard />} />
    {isAnAdmin(role) && (
      <Route exact path={routes.people.path} render={() => <People />} />
    )}
    {(isCommercialRole(role) || isPartnerAdmin(role)) && (
      <Route exact path={routes.lead.path} render={() => <Lead />} />
    )}
    {(isCommercialRole(role) || isPartnerAdmin(role)) && (
      <Route
        exact
        path={`${routes.lead.path}/:leadId`}
        render={({
          match: {
            params: { leadId }
          }
        }) => <LeadDetail leadId={leadId} />}
      />
    )}
    <Route
      exact
      path={routes.accountManagement.path}
      render={() => <Account />}
    />
    <Redirect to={routes.home.path} />
  </Switch>
);

PartnerSwitch.propTypes = {
  routes: PropTypes.object,
  role: PropTypes.string
};

export default connect(({ authentication }) => ({
  role: authentication?.role
}))(PartnerSwitch);
